import firebase from 'firebase/compat/app';

const getDownloadUrl = (path: string) => {
  return firebase.storage().ref(path).getDownloadURL();
};

export default getDownloadUrl;
